import React, { FC, Dispatch, SetStateAction } from "react";
import * as AV from "../../AVCore/AVCore";
import AVPostPopup from "../../components/common/AVPostPopup";

interface Props {
  visibilityPermission: string;
  setShowCreatePost: any;
  Postdata: any;
  setFeedChunks: any;
  feedChunks: any;
  onEmojiClick?: (
    emojiObject: { native: string },
    isFormattedPost: boolean,
  ) => void;
  handleAddComment: any | undefined;
  handlePostComment: any | undefined;
  showAddComment: any | false;
  setShowAddComment: any | undefined;
  setCommentMedia: any | undefined;
  isHuddlePostTab: any | false;
  boostPostOwner?: AV.IFK;
  paySend: number;
  setPaySend: Dispatch<SetStateAction<number>>;
  subject: string;
  setSubject: Dispatch<SetStateAction<string>>;
  estimate: number | null;
  setEstimate: Dispatch<SetStateAction<number | null>>;
  showBoostPostPopup: boolean;
  setShowBoostPostPopup: Dispatch<SetStateAction<boolean>>;
  showCreditsPopup: boolean;
  setShowCreditsPopup: Dispatch<SetStateAction<boolean>>;
  visibility?: string;
  handleToggleRichTextPost?: () => void;
  sharedPlan?: AV.ISharedPlan;
  setSharedPlan?: (plan: AV.ISharedPlan) => void;
}

const CreatePostpopup: FC<Props> = ({
  setShowCreatePost,
  Postdata,
  visibilityPermission,
  setFeedChunks,
  feedChunks,
  onEmojiClick,
  handleAddComment,
  handlePostComment,
  showAddComment,
  setShowAddComment,
  setCommentMedia,
  isHuddlePostTab,
  boostPostOwner,
  paySend,
  setPaySend,
  subject,
  setSubject,
  estimate,
  setEstimate,
  showBoostPostPopup,
  setShowBoostPostPopup,
  handleToggleRichTextPost,
  showCreditsPopup,
  setShowCreditsPopup,
  visibility,
  sharedPlan,
  setSharedPlan,
}) => {
  return (
    <AVPostPopup
      visibilityPermission={visibilityPermission}
      Postdata={Postdata}
      setShowCreatePost={setShowCreatePost}
      type={"Create"}
      setFeedChunks={setFeedChunks}
      feedChunks={feedChunks}
      onEmojiClick={onEmojiClick}
      handleAddComment={handleAddComment}
      handlePostComment={handlePostComment}
      showAddComment={showAddComment}
      setShowAddComment={setShowAddComment}
      setCommentMedia={setCommentMedia}
      isHuddlePostTab={isHuddlePostTab}
      boostPostOwner={boostPostOwner}
      paySend={paySend}
      setPaySend={setPaySend}
      subject={subject}
      setSubject={setSubject}
      estimate={estimate}
      setEstimate={setEstimate}
      showBoostPostPopup={showBoostPostPopup}
      setShowBoostPostPopup={setShowBoostPostPopup}
      showCreditsPopup={showCreditsPopup}
      setShowCreditsPopup={setShowCreditsPopup}
      estimateVisibility={visibility}
      sharedPlan={sharedPlan}
      setSharedPlan={setSharedPlan}
    />
  );
};

export default CreatePostpopup;
